import { map } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Command, CommandBase, FilteredCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Observable } from 'rxjs';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ChangeBankTransactionStatusFormComponent } from '../../component/change-bank-transaction-status/change-bank-transaction-status-form.component';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class ChangeBankTransactionImportStatusCommandHandler implements ICommandHandler {
  constructor(
    private _actionWindow: ActionWindowService,
    private _injector: Injector,
    private _navigationService: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return true;
    }

    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }

    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      return this._actionWindow
        .open(ChangeBankTransactionStatusFormComponent, this._injector, null, {
          commandContext: command.context,
          bankTransactionStatus: command.id,
        })
        .pipe(
          map(() => {
            this._navigationService.reloadAndNavigateToList();
          })
        );
    }

    if (command instanceof FilteredCommand) {
      return this._actionWindow
        .open(ChangeBankTransactionStatusFormComponent, this._injector, null, {
          filter: command.filterProvider.filterState,
          includedIds: command.includedIds,
          excludedIds: command.excludedIds,
          affectedItemsCount: command.totalAffectedItemsControlValue,
          bankTransactionStatus: command.id,
        })
        .pipe(
          map(() => {
            this._navigationService.reloadAndNavigateToList();
          })
        );
    }
  }
}
